<template>
  <div>
    <div id="login--form">
      <div class="modal-content">
        <div>
          <h1 class="modal-header">
            <strong v-t="`${langRoot}.title`" />
          </h1>
          <hr />
          <p data-ci="recover-username-message" v-t="`${langRoot}.helper`" />
          <br />
        </div>

        <footer class="modal-card-foot">
          <div class="level">
            <div class="level-left">&nbsp;</div>
            <div class="level-right">
              <button class="btn primary" @click="goToLoginPage()" v-t="`${langRoot}.okBtn`" />
            </div>
          </div>
        </footer>
      </div>
      <!-- /modal-content -->
    </div>
    <!-- /login-modal -->
  </div>
</template>

<script>
import tracking from '@shared/mixins/tracking';

const name = 'recoveruser';
export default {
    name,
    componentName: name,

    mixins: [tracking],

    data() {
        return {
            langRoot: 'recoverUserScreen',
        };
    },

    methods: {
        goToLoginPage() {
            this.$trackEvent(this.pageTag, 'recover_username_instruction');
            this.$router.push({ name: 'Login' });
        },
    },
};
</script>



// WEBPACK FOOTER //
// login/Components/RecoverUser.vue